export const authSelector = (state) => state.authModule;
